import React from "react";
import { Link } from "react-router-dom";
import { AppBar, Toolbar, Fab } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useActionBottomBarStyles } from "./css";
import { Button } from "../components";

interface INavigationBar {
  btnIcon?: React.ReactNode;
  btnText?: string;
  btnOnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  btnLink?: string;
}

function ActionBottomBar(props: INavigationBar) {
  const { btnIcon, btnText, btnOnClick, btnLink } = props;
  const { classes } = useActionBottomBarStyles();

  return (
    <div>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{ top: "auto", bottom: 0 }}
        classes={{
          root: classes.root,
        }}
      >
        <Toolbar className={classes.toolbar}>
          {btnOnClick && (
            <Fab
              color="primary"
              className={classes.addButton}
              onClick={btnOnClick}
            >
              <Add fontSize="large" />
            </Fab>
          )}

          {btnLink && (
            <div className={classes.link}>
              <Link to={btnLink ? btnLink : "/"}>
                <Button color="primary" startIcon={btnIcon}>
                  {btnText}
                </Button>
              </Link>
            </div>
          )}
        </Toolbar>
      </AppBar>
      {/* Workaround for css. Otherwise other elements hide behind appbar */}
      <Toolbar />
    </div>
  );
}

export default React.memo(ActionBottomBar);
